import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import Home from './pages/home';
import AboutUs from './pages/about';
import Product from './pages/product';
import Vendor from './pages/vendorlist'
import 'bootstrap/dist/css/bootstrap.min.css';
import VendorListing from './pages/vendorlistingwithmap';
import ProductDetail from './pages/productdetail';
import SignUpForm from './pages/signup';
import BasicInfoForm from './pages/basicinformation';
import Firstlisting from './pages/firstlisting';
import SellerProfile from './pages/sellerprofile';
import Socialmedia from './pages/socialmedia';
import Completesetup from './pages/completesetup';
import Thankyou from './pages/thankyou'
import Return from './pages/return'
import Expired from './pages/expired'
import Close from './pages/close';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/signUpForm" element={<SignUpForm />} />
          <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/about" element={<><Header /><AboutUs /><Footer /></>} />
          <Route path="/product" element={<><Header /><Product /><Footer /></>} />
          <Route path="/vendor" element={<><Header /><Vendor /><Footer /></>} />
          <Route path="/vendorlistingwithmap" element={<><Header /><VendorListing /><Footer /></>} />
          <Route path="/product/:id" element={<><Header /><ProductDetail /><Footer /></>} />
          <Route path="/signup" element={<SignUpForm />} />
          <Route path="/basicinformation" element={<BasicInfoForm />} />
          <Route path="/firstlisting" element={<Firstlisting />} />
          <Route path="/sellerprofile" element={<SellerProfile />} />
          <Route path="/socialmedia" element={<Socialmedia />} />
          <Route path="/completesetup" element={<Completesetup />} />
          <Route path="/thankyou" element={<Thankyou />} />
          <Route path="/expired" element={<Expired />} />
          <Route path="/return" element={<Return />} />
          <Route path="/close" element={<Close />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
